// extracted by mini-css-extract-plugin
export default {"container":"cards_container__znWAr","cards":"cards_cards__qNJj5","title":"cards_title__mMhBe","loading":"cards_loading__IuQ-W"};